import { Box, styled } from '@mui/joy';

export const SubtitleWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '4px',
  flexWrap: 'wrap',
});
